import Cookies from "js-cookie";

const getAuthToken = () => {
  const token = Cookies.get("auth_token");
  return token;
};

const setAuthToken = (token) => {
  Cookies.set("auth_token", token);
};

const removeAuthToken = () => {
  Cookies.remove("auth_token");
};

export { getAuthToken, setAuthToken, removeAuthToken };
